import { Component, inject, signal } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CLOSE_HANDLER_TOKEN, SUBSCRIBE_HANDLER_TOKEN } from './subscribe-handle.token';

@Component({
  selector: 'app-subscribe-push-notification-overlay-panel',
  imports: [MatButton, MatIconButton, MatIcon, MatProgressSpinner],
  templateUrl: './subscribe-push-notification-overlay-panel.component.html',
  host: {
    class:
      'relative max-w-sm w-[360px] bg-[#2c2c2c] border-[#2c2c2c] rounded-xl shadow-lg border p-4 flex flex-col gap-3 top-2',
  },
})
export class SubscribePushNotificationOverlayPanelComponent {
  readonly #subscribeHandler = inject(SUBSCRIBE_HANDLER_TOKEN);
  readonly #closeHandler = inject(CLOSE_HANDLER_TOKEN);

  protected readonly loading = signal(false);

  protected onClickSubscribe(): void {
    this.#subscribeHandler(loading => this.loading.set(loading));
  }

  protected onClickClose(): void {
    this.#closeHandler();
  }
}
